import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Video from 'yet-another-react-lightbox/plugins/video';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/counter.css';
import { mediaUrl } from '@/lib/api';

/**
 * useAdLightbox: reusable hook to open a lightbox for an ad media array.
 * Returns { open, LightboxRoot }.
 */
export function useAdLightbox(media) {
    const [openIndex, setOpenIndex] = useState(-1);

    const slides = (media || []).map(m => {
        if (m.kind === 'video') {
            return {
                type: 'video',
                width: 1280, height: 720,
                sources: [{ src: mediaUrl(m.url), type: 'video/mp4' }],
            };
        }
        if (m.kind === 'youtube') {
            return { src: `https://img.youtube.com/vi/${m.url}/hqdefault.jpg`, alt: 'youtube' };
        }
        return { src: mediaUrl(m.url), alt: 'foto' };
    });

    const open = (i = 0) => setOpenIndex(i);
    const close = () => setOpenIndex(-1);

    const LightboxRoot = (
        <Lightbox
            open={openIndex >= 0}
            close={close}
            slides={slides}
            index={openIndex >= 0 ? openIndex : 0}
            plugins={[Video, Thumbnails, Counter, Zoom]}
            counter={{ container: { style: { top: 0, left: 0 } } }}
            zoom={{ maxZoomPixelRatio: 3 }}
            controller={{ closeOnBackdropClick: true }}
            styles={{ container: { backgroundColor: 'rgba(0,0,0,.92)' } }}
        />
    );

    return { open, LightboxRoot, openIndex };
}
